import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import chakraTheme from "./theme/chakra-theme";
import App from "./App";
import global_en from "./translations/en/global.json";
import global_es from "./translations/es/global.json";
import i18next from "i18next";
import store from "./store";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { ToastProvider } from "./context/ToastContext";
import "bootstrap/dist/css/bootstrap.css";
import "rsuite/dist/rsuite.min.css";
import "./theme-light.css";
import "./theme-dark.css";
import "./theme-ocean.css";
import "./theme-forest.css";
import "./theme-sunset.css";
import "./theme-royal.css";
import "./theme-slate.css";
import "./theme-midnight.css";
import "./theme-ember.css";
import "./theme-arctic.css";
import "./theme-copper.css";
import "./theme-lavender.css";
import "./theme-emerald.css";
import "./theme-carbon.css";
import "./theme-wine.css";
import "./theme-sand.css";
import "./theme-cobalt.css";
import "./index.css";

i18next.init({
  interpolation: { escapeValue: false },
  lng: window.location.pathname.substring(1, 2) === "es" ? "es" : "en",
  resources: {
    en: {
      translation: global_en,
    },
    es: {
      translation: global_es,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={chakraTheme}>
      <I18nextProvider i18n={i18next}>
        <Provider store={store}>
          <ToastProvider>
            <App />
          </ToastProvider>
        </Provider>
      </I18nextProvider>
    </ChakraProvider>
  </React.StrictMode>
);
